import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const MyDriveApp = lazy(() => import('./MyDriveApp'));
const MyDriveAppTrashItems = lazy(() => import('./MyDriveAppTrashItems'));

const MyDriveAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/my-drive',
      element: <MyDriveApp />,
    },
    {
      path: 'apps/my-drive/folder/:folderId',
      element: <MyDriveApp />,
    },
    {
      path: 'apps/my-drive/trash',
      element: <MyDriveAppTrashItems />,
    },
  ],
};

export default MyDriveAppConfig;
